<template>
  <FriedIconButton
    data-external="signing-option-chat-button"
    :class="{ 'shake-chat-icon': newCommentsCount }"
  >
    <FriedIcon class="chat-icon" icon="conversation" />
    <FriedH5 v-if="newCommentsCount > 0" class="count-bubble">
      {{ newCommentsCount }}
    </FriedH5>
  </FriedIconButton>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    newCommentsCount: {
      type: Number,
      default: 0,
    },
  },
});
</script>

<style lang="scss" scoped>
$count-bubble-size: 1rem;

.shake-chat-icon {
  animation: shake 5s infinite linear;
}

.count-bubble {
  position: absolute;
  top: var(--spacing-25);
  right: var(--spacing-25);
  background: var(--error-dark);
  height: $count-bubble-size;
  min-width: $count-bubble-size;
  width: fit-content;
  border-radius: 50%;
  color: var(--white);
}
</style>
